const Images = {
  Logo: require('../../assets/images/logo.png'),
};

export default Images;
